<template>
  <mv-page>
    <mv-default-row>
      <v-layout row wrap>
        <v-flex xs12>
          <h1>Страница не найдена 404 :(</h1>
        </v-flex>
      </v-layout>
    </mv-default-row>
  </mv-page>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>
